/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The definition's own editable fields.
 * 
 * ``owner`` is not among them: moving a definition between companies would silently invalidate
 * every reference param configured on it. Duplicating to another company is a separate,
 * explicit operation that clears them.
 * @export
 * @interface PatchedWorkflowDefWriteRequest
 */
export interface PatchedWorkflowDefWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedWorkflowDefWriteRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedWorkflowDefWriteRequest
     */
    description?: string;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof PatchedWorkflowDefWriteRequest
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof PatchedWorkflowDefWriteRequest
     */
    autoEventLinking?: boolean;
}

/**
 * Check if a given object implements the PatchedWorkflowDefWriteRequest interface.
 */
export function instanceOfPatchedWorkflowDefWriteRequest(value: object): value is PatchedWorkflowDefWriteRequest {
    return true;
}

export function PatchedWorkflowDefWriteRequestFromJSON(json: any): PatchedWorkflowDefWriteRequest {
    return PatchedWorkflowDefWriteRequestFromJSONTyped(json, false);
}

export function PatchedWorkflowDefWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedWorkflowDefWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
    };
}

export function PatchedWorkflowDefWriteRequestToJSON(json: any): PatchedWorkflowDefWriteRequest {
    return PatchedWorkflowDefWriteRequestToJSONTyped(json, false);
}

export function PatchedWorkflowDefWriteRequestToJSONTyped(value?: PatchedWorkflowDefWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

